import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-rubel', 'IconCurrencyRubel', [
  ['path', { d: 'M8 19v-14h6a3 3 0 0 1 0 6h-8', key: 'svg-0' }],
  ['path', { d: 'M14 15h-8', key: 'svg-1' }],
]);
